import { defineComponent as _defineComponent } from 'vue'
import FilterIcon from '@/components/svg/filter.svg?inline';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXFilterTabs',
  props: {
  filters: {
    type: Object as PropType<Record<string, string>>,
    default: () => ({})
  },
  activeFilter: {
    type: String,
    required: true,
    default: 'ALL'
  }
},
  emits: ['setFilter'],
  setup(__props, { emit }) {

const props = __props;





function isFilterActive(key: any): boolean {
  return key === props.activeFilter;
}


return { __sfc: true,props, emit, isFilterActive, FilterIcon }
}

})